import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/repository/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/repository/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/repository/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/repository/save', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/repository/update', params, options);
export const saveCatalog = (params, options) =>
  request.post('/api/v4ward/repository/saveCatalog', params, options);

export const updateCatalog = (params, options) =>
  request.post('/api/v4ward/repository/updateCatalog', params, options);

export const deleteCatalog = (params, options) =>
  request.post('/api/v4ward/repository/deleteCatalog', qs.stringify(params), options);
export const getDetailById = (params, options) =>
  request.get('/api/v4ward/repository/detailById', Object.assign({}, options, { params }));

//知识库懒加载
export const lazyTree = (parentId) => {
  return request({
    url: '/api/v4ward/repository/lazyTree',
    method: 'get',
    params: {
      parentId,
    },
  });
};
